/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */

import React, { useState, useRef } from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { Modal, ModalBody, Button } from 'reactstrap';

function PrevArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{
        ...style, display: 'block', left: '-40px', zIndex: 1,
      }}
      onClick={onClick}
    >
      ❮
    </div>
  );
}

function NextArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{
        ...style, display: 'block', right: '-40px', zIndex: 1,
      }}
      onClick={onClick}
    >
      ❯
    </div>
  );
}

function ImageCarouselModal({ isOpen, images = [], toggle }) {    

  const [selectedIndex, setSelectedIndex] = useState(0);
  const sliderRef = useRef(null); 

  const settings = {
    dots: false,
    infinite: images.length > 1, 
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: images.length > 1, 
    prevArrow: <PrevArrow />,
    nextArrow: <NextArrow />,
    beforeChange: (current, next) => setSelectedIndex(next),
  };

  const goToSlide = (index) => {
    if (sliderRef.current) {
      sliderRef.current.slickGoTo(index);
      setSelectedIndex(index);
    }
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} size="lg">
      <ModalBody style={{ textAlign: 'center', position: 'relative' }}>
        {/* Slider de imagens */}
        <Slider {...settings} ref={sliderRef} initialSlide={selectedIndex}>
          {images.map((image, index) => (
            <div key={index} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              <img
                src={image.url}
                alt={image.description}
                style={{ width: '100%', height: 'auto', objectFit: 'contain', borderRadius: '10px' }}
              />
            </div>
          ))}
        </Slider>

        <div
          style={{
          display: 'flex',
          justifyContent: 'center',
          marginTop: '10px',
          marginBottom: '10px',
          gap: '10px',
          paddingBottom: '10px',
          flexWrap: 'wrap',
        }}
        >
          {images.map((image, index) => (
            <img
              key={index}
              src={image.url}
              alt={image.description}
              onClick={() => {
                setSelectedIndex(index);
                sliderRef.current?.slickGoTo(index);
              }}
              style={{
                width: '50px',
                height: '50px',
                objectFit: 'cover',
                borderRadius: '5px',
                cursor: 'pointer',
                border: selectedIndex === index ? '2px solid black' : '2px solid transparent',
              }}
            />
          ))}
        </div>

        {/* {images.length > 1 && (
          <div style={{ display: 'flex', justifyContent: 'center', marginTop: '10px' }}>
            {images.map((image, index) => (
              <img
                key={index}
                src={image.url}
                alt={image.description}
                onClick={() => goToSlide(index)}
                style={{
                  width: '50px',
                  height: '50px',
                  objectFit: 'cover',
                  borderRadius: '5px',
                  margin: '5px',
                  cursor: 'pointer',
                  border: selectedIndex === index ? '2px solid black' : '2px solid transparent',
                }}
              />
            ))}
          </div>
        )} */}

        <div style={{ marginTop: '15px', textAlign: 'right' }}>
          <Button color="secondary" onClick={toggle}>Voltar</Button>
        </div>
      </ModalBody>
    </Modal>
  );
}

export default ImageCarouselModal;
